import { render, staticRenderFns } from "./veStuYystuShow.vue?vue&type=template&id=714ab248&scoped=true"
import script from "./veStuYystuShow.vue?vue&type=script&lang=js"
export * from "./veStuYystuShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714ab248",
  null
  
)

export default component.exports